import { ITDisplayImage, ITBooleanRender } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { ITInputSelectWithSeachBar } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'
import { DictionaryComponents } from '../../../../utils/globals/types'
import { OrderRectangularInputSmall, OrderEditableText, ITOrderBooleanRectangle, OrderCustomSelectBlockedItemsSearchbar, OrderInputQuantity, OrderInputQuantity2, OrderEditableName } from '../OrderLayout/OrderTable/TableComponents/Inputs'
import OrderSearchProductInput, { OrderSearchProductInputName, OrderSearchProductInputReferenceAndName, OrderSearchProductInputCreate } from '../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput'
import OrderEditProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditProduct'
import OrderUniqueNumberProduct, { OrderUniqueNumberProductReadOnly } from '../OrderLayout/OrderTable/TableComponents/OrderUniqueNumberProduct'
import { OrderDragHandle } from '../OrderLayout/OrderTable/TableComponents/Sorts'
import InputTableWorkSheetLayout, { InputTableWorkSheetLayoutNew } from './InputTableWorkSheetLayout'
import { useWorkSheetLayoutTableLogic } from './useWorkSheetLayoutTableLogic'
import { InputTableHookWSFullProps, InputTableWorkSheetLayoutProps } from './types'
import WorkSheetProductStatusSelector from '../OrderLayout/OrderTable/TableComponents/Inputs/WorkSheetProductStatusSelector'
import ModalEditableTextProductOrder from '../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditableTextProductOrder'
import ModalUniqueNumberProductOrderSell from '../OrderSellLayout/ModalsOrderSellLayout/ModalUniqueNumberProductOrderSell'
import { UserPermissions } from '../../../../baseComponents/CreateRoutering/types'
import { ITLayoutTableModalOpen } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { InputTableURLsTable, InputTableLayoutData } from '../../../../baseComponents/TwinTable/InputTableLayout/types'
import { BuildedOrder } from '../../../../baseComponents/TwinTable/types'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { WorkSheetCheckbox } from '../../../sells/components'
import AppStyleDecider from '../../../../baseComponents/AppsStyleDecider'

interface WorkSheetLayoutProps extends InputTableWorkSheetLayoutProps {
}

const WorkSheetLayout: React.FC<WorkSheetLayoutProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={WorkSheetLayoutDefault} NewComponent={WorkSheetLayoutNew} {...rest} />
    )
}

const WorkSheetLayoutDefault: React.FC<WorkSheetLayoutProps> = ({ ...rest }) => {
    return (
        <InputTableWorkSheetLayout {...rest} components={components} hookFunction={useWorkSheetLayoutTableLogic} TableChildren={WorkSheetTableChildren} />
    )
}

const WorkSheetLayoutNew: React.FC<WorkSheetLayoutProps> = ({ ...rest }) => {
    return (
        <InputTableWorkSheetLayoutNew {...rest} components={components} hookFunction={useWorkSheetLayoutTableLogic} TableChildren={WorkSheetTableChildren} />
    )
}

const WorkSheetTableChildren: React.FC<InputTableHookWSFullProps> = ({ completeData, CurrencyId, eventFunctions, ...rest }) => {
    return (
        <ModalsWorkSheetLayout {...rest} headerData={completeData?.header || {}} onChangeFetch={eventFunctions.onChangeFetch} completeData={completeData}/>
    )
}
interface ModalsWorkSheetLayoutProps {
    openModal: ITLayoutTableModalOpen
    setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>
    inputTableURLs: InputTableURLsTable
    userPermissions: UserPermissions
    headerData: TwinDictionary
    getCompleteData: (order?: BuildedOrder) => Promise<void>
    onChangeFetch: (rowIndex: number, keyValue: string, value: string) => Promise<void>
    completeData: InputTableLayoutData | null
}

const ModalsWorkSheetLayout: React.FC<ModalsWorkSheetLayoutProps> = ({ openModal, onChangeFetch, setOpenModal, ...rest }) => {
    const typeDict: any = {
        editableText: { component: ModalEditableTextProductOrder, onSubmit: (value: any) => onChangeFetch(openModal?.allRowData.absoluteIndex || openModal?.allRowData.rowIndex, openModal?.allRowData.dataKey, value) },
        uniqueNumber: { component: ModalUniqueNumberProductOrderSell, onSubmit: onChangeFetch },
    }
    if (openModal?.type && openModal.type in typeDict) {
        const element = typeDict[openModal.type]
        const Component = element.component
        const onSubmit = element.onSubmit
        return <Component allRowData={openModal.allRowData} {...rest} orderURLs={rest.inputTableURLs} onSubmit={onSubmit} setOpened={() => setOpenModal(null)} tableData={rest.completeData?.tableData} />
    }
    return null
}

const components: DictionaryComponents = {
    ITRectangularInput: OrderRectangularInputSmall,
    ITEditableText: OrderEditableText,
    ITEditableName: OrderEditableName,
    OrderSearchProductInput: OrderSearchProductInput,
    OrderSearchProductInputName: OrderSearchProductInputName,
    OrderSearchProductInputReferenceAndName: OrderSearchProductInputReferenceAndName,
    OrderSearchProductInputCreate: OrderSearchProductInputCreate,
    ITOrderBooleanRectangle: ITOrderBooleanRectangle,
    ITSelectSpecificPriceRule: OrderCustomSelectBlockedItemsSearchbar,
    ITInputQuantity: OrderInputQuantity,
    ITInputQuantity2: OrderInputQuantity2,
    ITDragHandle: OrderDragHandle,
    OrderEditProduct: OrderEditProduct,
    ITDisplayImage: ITDisplayImage,
    ITBooleanRender: ITBooleanRender,
    ITInputSelectWithSeachBar: ITInputSelectWithSeachBar,
    OrderUniqueNumberProduct: OrderUniqueNumberProduct,
    OrderUniqueNumberProductReadOnly: OrderUniqueNumberProductReadOnly,
    WorkSheetProductStatusSelector: WorkSheetProductStatusSelector,
    CheckboxComponent: WorkSheetCheckbox
}

export default WorkSheetLayout